import { t } from "../lib/i18n";
import PublicNavbar from './PublicNavbar';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const FAQ: React.FC = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  const faqs = [
    {
      question: 'What is CRE Dominion?',
      answer: 'CRE Dominion is a comprehensive, AI-powered platform designed for commercial real estate (CRE) professionals. It streamlines property management, deal sourcing, lease abstraction, market analysis, and more, helping you make data-driven decisions to build your real estate empire.',
    },
    {
      question: 'Who is CRE Dominion for?',
      answer: 'CRE Dominion is built for a wide range of CRE professionals, including building owners, property managers, asset managers, brokers, and investors. Whether you manage a single property or a large portfolio, our platform provides the tools you need to succeed.',
    },
    {
      question: 'What are the key features of CRE Dominion?',
      answer: 'Our key features include AI-driven lease abstraction, advanced deal sourcing and analysis, comprehensive property and tenant management, market analysis and predictive trends, property valuation, customizable reporting, and secure document management.',
    },
    {
      question: 'How does the lease abstraction feature work?',
      answer: 'Our AI-powered lease abstraction tool automatically extracts key information from your lease documents, such as start and end dates, rent amounts, clauses, and more. This saves you countless hours of manual data entry and reduces the risk of errors.',
    },
    {
      question: 'Is my data secure?',
      answer: 'Yes, data security is our top priority. We use industry-leading security measures, including encryption and secure cloud storage, to protect your sensitive information. Your data is safe, secure, and always accessible to you.',
    },
    {
      question: 'What kind of properties can I manage with CRE Dominion?',
      answer: 'You can manage a wide variety of commercial properties, including office buildings, retail spaces, industrial properties, and multi-family residential buildings.',
    },
    {
      question: 'How does the deal sourcing feature work?',
      answer: 'Our deal sourcing module uses advanced algorithms and market data to help you identify and evaluate potential investment opportunities that match your criteria. You can analyze deals, perform due diligence, and track your pipeline all in one place.',
    },
    {
      question: 'Can I generate custom reports?',
      answer: 'Yes, our platform includes a powerful reporting engine that allows you to generate a wide range of customizable reports on portfolio performance, financials, leasing activity, and more. These reports can be tailored to meet the needs of your stakeholders.',
    },
    {
      question: 'What is the pricing model?',
      answer: 'CRE Dominion operates on a flexible credit-based system. You purchase credits, which are then used to access various AI-powered features and advanced analytics. This allows you to pay only for what you use, scaling with your specific needs. Visit your account settings for credit purchase options and usage details.',
    },
    {
      question: 'How do I get started?',
      answer: 'Getting started is easy! You can sign up for a free trial directly from our website. After you sign up, you can start adding your properties and exploring the features of the platform right away.',
    },
  ];

  return (
    <div className="min-h-screen bg-slate-50 text-slate-800">
      <PublicNavbar />
      <div className="container mx-auto py-10 px-4 max-w-4xl">
      <Link to="/" className="inline-block mt-4 mb-8 bg-indigo-700 text-white font-bold px-6 py-3 rounded-lg shadow-md hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200 no-underline">{t("fAQ.k21")}</Link>
      <h2 className="text-2xl font-bold mb-4">{t("fAQ.k22")}</h2>
      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div key={index}>
            <h3 className="font-bold">{faq.question}</h3>
            <p>{faq.answer}</p>
          </div>
        ))}
      </div>
      </div>
    </div>
  );
};

export default FAQ;